import { putResolve, select } from "redux-saga/effects";
import { IResponse, IResult } from "redmond";

import Logger from "../../../utils/logger";
import { fetchLocations } from "../../../api/v0/search/fetchLocations";
import { getLocation } from "../../search/reducer";
import { actions as searchActions } from "../../search/actions";

export function* hydrateSelectedLocationSaga(locationName: string) {
  try {
    // Snapshot the location *before* the network call so we can detect any
    // user-driven change while the request was in flight. Reference equality
    // catches every setLocation dispatch (always a new object); comparing
    // against `locationName` instead would falsely bail on cross-location
    // navigation, since `locationName` is the raw URL slug (e.g. "Paris")
    // while the stored label is the canonical autocomplete result (e.g.
    // "Paris, France").
    const snapshot: IResult | undefined = yield select(getLocation);

    const { categories: locationCategories }: IResponse = yield fetchLocations();
    const updatedLocation = locationCategories.flatMap((category) =>
      category.results.find((result) =>
        result.label.toLowerCase().includes(locationName.toLowerCase())
      )
    );
    const resolved = updatedLocation[0] as IResult | undefined;
    if (resolved == null) return;

    // The spawned task outlives the parent saga. Bail if the user has set a
    // different location (e.g. typed in the search bar while this 7s
    // autocomplete was in flight) so we don't stomp their input.
    const current: IResult | undefined = yield select(getLocation);
    if (current !== snapshot) return;

    yield putResolve(searchActions.setLocation(resolved));
  } catch (e) {
    // Tagged so the silent (spawned-task) failure is filterable in Datadog —
    // this used to surface to the outer saga's catch when it was a blocking
    // `yield`, but now lives in a detached task.
    Logger.debug({
      tag: "premier_collection_chip_hydrate_failed",
      locationName,
      error: e,
    });
  }
}
